// A0 - Ünite 5: Zamirler & Possessives + Yolcu Eşyaları
// Hedef: Subject, Object, Possessive pronouns ve demonstratives

export const A0_UNIT_5 = {
  'A0-U5-L1': {
    id: 'A0-U5-L1',
    title: 'Subject Pronouns (Özne Zamirleri)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Özne Zamirleri',
          explanation: 'Özne zamirleri cümlenin başında, fiilden önce gelir ve eylemi yapanı belirtir.',
          table: {
            headers: ['Zamir', 'Türkçe', 'Örnek', 'Çeviri'],
            rows: [
              ['I', 'Ben', 'I am a cabin crew member.', 'Ben kabin memuruyum.'],
              ['You', 'Sen/Siz', 'You are welcome.', 'Hoş geldiniz.'],
              ['He', 'O (erkek)', 'He is the captain.', 'O kaptan.'],
              ['She', 'O (kadın)', 'She is Turkish.', 'O Türk.'],
              ['It', 'O (nesne/hayvan)', 'It is delayed.', 'Gecikti.'],
              ['We', 'Biz', 'We are ready.', 'Biz hazırız.'],
              ['They', 'Onlar', 'They are passengers.', 'Onlar yolcu.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "I" her zaman büyük harfle yazılır! Diğer zamirler cümle başında değilse küçük harfle yazılır.'
        },
        {
          type: 'tip',
          content: '💡 "It" canlılar için kullanılmaz (evcil hayvanlar hariç). Uçak, hava durumu, saat için kullanılır: "It is raining.", "It is 3 o\'clock."'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'I am your flight attendant today.', tr: 'Bugün kabin memuruyunuzum.' },
            { en: 'He is the pilot.', tr: 'O pilot.' },
            { en: 'She is serving meals.', tr: 'O yemek servisi yapıyor.' },
            { en: 'It is a Boeing 737.', tr: 'Bu bir Boeing 737.' },
            { en: 'We are preparing for takeoff.', tr: 'Kalkışa hazırlanıyoruz.' },
            { en: 'They are boarding now.', tr: 'Onlar şu an biniyor.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'Doğru zamiri yazın',
          sentences: [
            { text: '___ am from Istanbul. (Ben)', answer: 'I' },
            { text: '___ is the purser. (O-kadın)', answer: 'She' },
            { text: '___ are passengers. (Onlar)', answer: 'They' },
            { text: '___ is on time. (Uçuş)', answer: 'It' },
            { text: '___ are the cabin crew. (Biz)', answer: 'We' }
          ]
        },
        {
          type: 'matching',
          pairs: [
            { left: 'Ben', right: 'I' },
            { left: 'O (erkek)', right: 'He' },
            { left: 'Onlar', right: 'They' },
            { left: 'Biz', right: 'We' },
            { left: 'O (nesne)', right: 'It' }
          ]
        }
      ]
    }
  },

  'A0-U5-L2': {
    id: 'A0-U5-L2',
    title: 'Object Pronouns (Nesne Zamirleri)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Nesne Zamirleri',
          explanation: 'Nesne zamirleri fiilden SONRA gelir ve eylemin yapıldığı kişi/şeyi belirtir.',
          table: {
            headers: ['Özne', 'Nesne', 'Örnek', 'Çeviri'],
            rows: [
              ['I', 'me', 'Help me.', 'Bana yardım et.'],
              ['You', 'you', 'I see you.', 'Seni görüyorum.'],
              ['He', 'him', 'Call him.', 'Onu ara.'],
              ['She', 'her', 'Ask her.', 'Ona sor.'],
              ['It', 'it', 'Take it.', 'Onu al.'],
              ['We', 'us', 'Join us.', 'Bize katıl.'],
              ['They', 'them', 'Help them.', 'Onlara yardım et.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📊 Karşılaştırma Tablosu',
          table: {
            headers: ['Özne (Subject)', 'Nesne (Object)'],
            rows: [
              ['I', 'me'],
              ['you', 'you'],
              ['he', 'him'],
              ['she', 'her'],
              ['it', 'it'],
              ['we', 'us'],
              ['they', 'them']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "You" ve "It" hem özne hem nesne olarak aynı kalır.'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'Can I help you?', tr: 'Size yardımcı olabilir miyim?' },
            { en: 'Please follow me.', tr: 'Lütfen beni takip edin.' },
            { en: 'I will bring it to you.', tr: 'Onu size getireceğim.' },
            { en: 'Let me assist her.', tr: 'Ona yardım edeyim.' },
            { en: 'Welcome aboard! Let us help you with your bags.', tr: 'Uçuşa hoş geldiniz! Çantalarınızda size yardımcı olalım.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'Doğru nesne zamirini yazın',
          sentences: [
            { text: 'Please help ___. (bana)', answer: 'me' },
            { text: 'I will call ___. (onu-erkek)', answer: 'him' },
            { text: 'Give ___ a blanket. (onlara)', answer: 'them' },
            { text: 'Follow ___. (bizi)', answer: 'us' },
            { text: 'Can you show ___ the exit? (ona-kadın)', answer: 'her' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"Please follow ___." (beni)',
          options: ['I', 'me', 'my', 'mine'],
          correctIndex: 1,
          explanation: 'Fiilden sonra nesne zamiri kullanılır: me'
        },
        {
          type: 'transform',
          instruction: 'Altı çizili kelimeleri zamirle değiştirin',
          sentences: [
            { original: 'Help the passenger.', answer: 'Help him/her.' },
            { original: 'Give the blanket to the lady.', answer: 'Give it to her.' }
          ]
        }
      ]
    }
  },

  'A0-U5-L3': {
    id: 'A0-U5-L3',
    title: 'Possessive Adjectives (İyelik Sıfatları)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 İyelik Sıfatları',
          explanation: 'İyelik sıfatları "kimin?" sorusuna cevap verir ve isimden ÖNCE gelir.',
          formula: 'Possessive Adjective + Noun'
        },
        {
          type: 'grammar',
          title: '📊 İyelik Sıfatları Tablosu',
          table: {
            headers: ['Özne', 'İyelik Sıfatı', 'Örnek', 'Çeviri'],
            rows: [
              ['I', 'my', 'my seat', 'benim koltuğum'],
              ['you', 'your', 'your bag', 'senin çantan'],
              ['he', 'his', 'his passport', 'onun pasaportu'],
              ['she', 'her', 'her ticket', 'onun bileti'],
              ['it', 'its', 'its wing', 'onun kanadı'],
              ['we', 'our', 'our flight', 'bizim uçuşumuz'],
              ['they', 'their', 'their luggage', 'onların bagajı']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 DİKKAT: "its" (onun - nesne) vs "it\'s" (it is kısaltması). Farklı!'
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'Please fasten your seatbelt.', tr: 'Lütfen emniyet kemerinizi bağlayın.' },
            { en: 'Is this your bag?', tr: 'Bu sizin çantanız mı?' },
            { en: 'Show me your boarding pass.', tr: 'Biniş kartınızı gösterin.' },
            { en: 'This is my seat.', tr: 'Burası benim koltuğum.' },
            { en: 'Our flight is delayed.', tr: 'Uçuşumuz gecikti.' },
            { en: 'Their luggage is lost.', tr: 'Onların bagajı kayboldu.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'Doğru iyelik sıfatını yazın',
          sentences: [
            { text: 'Please fasten ___ seatbelt. (sizin)', answer: 'your' },
            { text: 'This is ___ passport. (benim)', answer: 'my' },
            { text: '___ flight is at 3pm. (bizim)', answer: 'Our' },
            { text: 'She lost ___ bag. (onun-kadın)', answer: 'her' },
            { text: 'Is this ___ seat? (onun-erkek)', answer: 'his' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"The bird hurt ___ wing." Boşluğa ne gelir?',
          options: ['it\'s', 'its', 'his', 'her'],
          correctIndex: 1,
          explanation: 'Hayvan/nesne için "its" kullanılır. "It\'s" = "it is" demektir.'
        },
        {
          type: 'errorCorrection',
          sentences: [
            { wrong: 'Fasten you seatbelt.', correct: 'Fasten your seatbelt.' },
            { wrong: 'This is she bag.', correct: 'This is her bag.' },
            { wrong: 'I lost me passport.', correct: 'I lost my passport.' }
          ]
        }
      ]
    }
  },

  'A0-U5-L4': {
    id: 'A0-U5-L4',
    title: 'Demonstratives (This, That, These, Those)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 İşaret Sıfatları/Zamirleri',
          explanation: 'Demonstratives yakındaki veya uzaktaki şeyleri göstermek için kullanılır.',
          table: {
            headers: ['', 'Tekıl', 'Çoğul'],
            rows: [
              ['YAKIN', 'this (bu)', 'these (bunlar)'],
              ['UZAK', 'that (şu)', 'those (şunlar)']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📊 Kullanım Örnekleri',
          table: {
            headers: ['Demonstrative', 'Örnek', 'Açıklama'],
            rows: [
              ['this', 'This is your seat.', 'Tek, yakın'],
              ['that', 'That is the exit.', 'Tek, uzak'],
              ['these', 'These are your bags.', 'Çoğul, yakın'],
              ['those', 'Those are the emergency exits.', 'Çoğul, uzak']
            ]
          }
        },
        {
          type: 'grammar',
          title: '📚 BE Fiili ile Kullanım',
          table: {
            headers: ['Demonstrative', 'BE Fiili', 'Örnek'],
            rows: [
              ['This', 'is', 'This is your seat.'],
              ['That', 'is', 'That is the exit.'],
              ['These', 'are', 'These are the safety cards.'],
              ['Those', 'are', 'Those are the overhead bins.']
            ]
          }
        },
        {
          type: 'example',
          title: '✈️ Havacılık Örnekleri',
          items: [
            { en: 'This is row 15.', tr: 'Burası 15. sıra.' },
            { en: 'Is this your bag?', tr: 'Bu sizin çantanız mı?' },
            { en: 'That is the emergency exit.', tr: 'Şu acil çıkış.' },
            { en: 'These are complimentary headphones.', tr: 'Bunlar ücretsiz kulaklıklar.' },
            { en: 'Those passengers are VIP.', tr: 'Şu yolcular VIP.' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          instruction: 'This, That, These veya Those yazın',
          sentences: [
            { text: '___ is your seat. (yakın, tekil)', answer: 'This' },
            { text: '___ are the toilets at the back. (uzak, çoğul)', answer: 'Those' },
            { text: '___ are your bags. (yakın, çoğul)', answer: 'These' },
            { text: '___ is the cockpit. (uzak, tekil)', answer: 'That' }
          ]
        },
        {
          type: 'multipleChoice',
          question: '"___ are the emergency exits at the front." (uzak, çoğul)',
          options: ['This', 'That', 'These', 'Those'],
          correctIndex: 3
        },
        {
          type: 'matching',
          pairs: [
            { left: 'This', right: 'Tek, yakın' },
            { left: 'That', right: 'Tek, uzak' },
            { left: 'These', right: 'Çoğul, yakın' },
            { left: 'Those', right: 'Çoğul, uzak' }
          ]
        }
      ]
    }
  },

  'A0-U5-L5': {
    id: 'A0-U5-L5',
    title: 'Uygulama: Yolcu Eşyaları & Mülakat',
    type: 'practice',
    content: {
      sections: [
        {
          type: 'vocabulary',
          title: '💼 Yolcu Eşyaları',
          words: [
            { en: 'passport', tr: 'pasaport', example: 'May I see your passport?' },
            { en: 'boarding pass', tr: 'biniş kartı', example: 'Here is my boarding pass.' },
            { en: 'ID card', tr: 'kimlik kartı', example: 'Show me your ID card.' },
            { en: 'ticket', tr: 'bilet', example: 'Is this your ticket?' },
            { en: 'luggage', tr: 'bagaj', example: 'This is my luggage.' },
            { en: 'carry-on bag', tr: 'kabin bagajı', example: 'Put your carry-on under the seat.' },
            { en: 'handbag', tr: 'el çantası', example: 'Keep your handbag with you.' },
            { en: 'laptop', tr: 'dizüstü bilgisayar', example: 'Take out your laptop.' }
          ]
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo: Eşya Kontrolü',
          dialogues: [
            {
              speaker: 'Kabin Memuru',
              text: 'Excuse me, is this your bag?',
              translation: 'Affedersiniz, bu sizin çantanız mı?'
            },
            {
              speaker: 'Yolcu',
              text: 'Yes, it is. This is my carry-on.',
              translation: 'Evet. Bu benim kabin bagajım.'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'Please put it in the overhead bin.',
              translation: 'Lütfen üst bagaj bölümüne koyun.'
            },
            {
              speaker: 'Yolcu',
              text: 'Where is my seat?',
              translation: 'Koltuğum nerede?'
            },
            {
              speaker: 'Kabin Memuru',
              text: 'Your seat is 23A. That is the window seat in row 23.',
              translation: 'Koltuğunuz 23A. 23. sırada pencere kenarı.'
            }
          ]
        },
        {
          type: 'interview',
          title: '🎭 Mülakat Sorusu',
          question: 'Why do you want to be a cabin crew member?',
          sampleAnswer: 'I want to be a cabin crew member because I love traveling and meeting new people. I am friendly and helpful. I can speak English and Turkish. This is my dream job.',
          keyPhrases: [
            'I want to be...',
            'I love...',
            'I am...',
            'I can...',
            'This is my...'
          ]
        }
      ],
      exercises: [
        {
          type: 'fillBlank',
          sentences: [
            { text: 'Is ___ your passport? (bu)', answer: 'this' },
            { text: 'Please show ___ your boarding pass. (bana)', answer: 'me' },
            { text: '___ seat is 15A. (sizin)', answer: 'Your' },
            { text: 'Can you help ___ with my bag? (bana)', answer: 'me' },
            { text: '___ is the emergency exit. (şu-uzak)', answer: 'That' }
          ]
        },
        {
          type: 'speaking',
          instruction: 'Aşağıdaki cümleleri İngilizce söyleyin',
          items: [
            { tr: 'Bu benim koltuğum.', en: 'This is my seat.' },
            { tr: 'Bana yardım edebilir misiniz?', en: 'Can you help me?' },
            { tr: 'Şu sizin çantanız mı?', en: 'Is that your bag?' }
          ]
        }
      ]
    }
  },

  'A0-U5-EXAM': {
    id: 'A0-U5-EXAM',
    title: '📝 Ünite 5 Sınavı',
    type: 'exam',
    content: {
      timeLimit: 15,
      passingScore: 80,
      questions: [
        {
          type: 'multipleChoice',
          question: '"___ am a cabin crew member." Boşluğa ne gelir?',
          options: ['Me', 'My', 'I', 'Mine'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: '"Please help ___." (bana) Boşluğa ne gelir?',
          options: ['I', 'my', 'me', 'mine'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: '"Fasten ___ seatbelt." (sizin) Boşluğa ne gelir?',
          options: ['you', 'your', 'yours', 'you\'re'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: '"___ is your seat." (yakın, tekil) Boşluğa ne gelir?',
          options: ['This', 'That', 'These', 'Those'],
          correctIndex: 0
        },
        {
          type: 'multipleChoice',
          question: '"___ are the emergency exits." (uzak, çoğul) Boşluğa ne gelir?',
          options: ['This', 'That', 'These', 'Those'],
          correctIndex: 3
        },
        {
          type: 'multipleChoice',
          question: '"She lost ___ passport." Boşluğa ne gelir?',
          options: ['she', 'her', 'hers', 'she\'s'],
          correctIndex: 1
        },
        {
          type: 'fillBlank',
          question: '"Can you help ___?" (onlara)',
          answer: 'them'
        },
        {
          type: 'fillBlank',
          question: '"___ flight is delayed." (bizim)',
          answer: 'Our'
        }
      ]
    }
  }
};

export default A0_UNIT_5;
